import { Component, computed, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ProfileEditComponent } from '../../dialogs/profile-edit/profile-edit.component';
import { ContactEditComponent } from '../../dialogs/contact-edit/contact-edit.component';
import { dataStore, dataStoreSignal } from 'src/app/app.component';
import { MatCard, MatCardHeader, MatCardTitle, MatCardContent } from '@angular/material/card';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { NgClass, DatePipe } from '@angular/common';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-profile-content',
  templateUrl: './profile-content.component.html',
  styleUrls: ['./profile-content.component.scss'],
  imports: [
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatIconButton,
    MatIcon,
    MatCardContent,
    NgClass,
    MatTooltip,
    DatePipe,
  ],
})
export class ProfileContentComponent implements OnInit {
  ds = dataStoreSignal;

  streetInfo = computed(() => {
    const user = this.ds().orgUser;
    if (user?.streetName) {
      let info = user.streetName;
      if (user.houseNumber) {
        info += ` ${user.houseNumber}`;
        if (user.houseNumberAddition) {
          info += ` - ${user.houseNumberAddition}`;
        }
      }
      return info;
    } else {
      return 'Geen';
    }
  });

  constructor(public dialog: MatDialog) {}

  async ngOnInit() {}

  editProfile() {
    this.dialog.open(ProfileEditComponent, {
      width: '500px',
      autoFocus: false,
    });
  }

  editContactInfo(type: string) {
    this.dialog.open(ContactEditComponent, {
      width: '500px',
      data: {
        type,
        userId: dataStore.orgUser.id,
        userData: {
          email: dataStore.rootUser.email ?? '',
          phone: dataStore.orgUser.phoneNumber ?? '',
          emergencyPhones: dataStore.orgUser.emergencyPhoneNumbers ?? [],
        },
      },
      autoFocus: false,
    });
  }
}
